import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

const ONE_BUSINESS_DAY = 1000 * 60 * 60 * 14;

export default () => {
  if (import.meta.env.VITE_NODE_ENV === 'production' && !import.meta.env.VITE_IS_STAGING) {
    return null;
  }

  const lastOpened = localStorage.getItem('devStatus_lastOpened');

  const [open, setOpen] = useState(
    lastOpened ? Date.now() - parseInt(lastOpened, 10) >= ONE_BUSINESS_DAY : true
  );

  const handleClose = (event, reason?) => {
    if (reason && reason === 'backdropClick') return;
    localStorage.setItem('devStatus_lastOpened', Date.now().toString());
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Achtung</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Das Dashboard befindet sich noch in der aktiven Entwicklung. Es kann jederzeit passieren,
          dass es zu unbeabsichtigten Fehlern kommt. Einzelne Komponenten, das Layout oder Design
          können sich auch kurzfristig ändern.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Verstanden
        </Button>
      </DialogActions>
    </Dialog>
  );
};
